import type { ModelMessage } from "ai";
import { z } from "zod";
import { ToneDefinitionIdSchema } from "./ToneDefinition.js";

/** ChatMessage stuff is unused for now, see ChatThread below */
export const ChatMessageContentSchema = z.custom<ModelMessage>();
export type ChatMessageContent = z.infer<typeof ChatMessageContentSchema>;
export const ChatMessageSchema = z.object({
  id: z.uuid(),
  organizationId: z.uuid(),
  creatorId: z.uuid().nullable(),
  chatThreadId: z.uuid().nullable(),
  createdAt: z.date(),
  role: z.string(),
  content: ChatMessageContentSchema,
});
export type ChatMessage = z.infer<typeof ChatMessageSchema>;

export const ChatThreadConfigurationSchema = z.object({
  toneDefinitionId: ToneDefinitionIdSchema.optional(),
  externalSource: z
    .object({
      sourceName: z.enum(["whatsapp"]),
      sourceId: z.string(),
    })
    .optional(),
});

export const ChatThreadContentSchema = z.object({
  activeMessages: z.array(z.record(z.string(), z.any())).optional().default([]),
  previousMessages: z
    .array(z.record(z.string(), z.any()))
    .optional()
    .default([]),
});

export type ChatThreadContent = z.infer<typeof ChatThreadContentSchema>;

export const ChatThreadSchema = z.object({
  id: z.uuid(),
  organizationId: z.uuid(),
  creatorId: z.uuid(),
  createdAt: z.date(),
  removedAt: z.date().nullable(),
  title: z.string().nullable(),
  titleIsLocked: z.boolean(),
  lockedForSummarization: z.boolean(),
  private: z.boolean(),
  contextKey: z.string(),
  summary: z.string().nullable(),
  summaryCreatedAt: z.date().nullable(),
  configuration: ChatThreadConfigurationSchema,
  content: ChatThreadContentSchema,
});

export type ChatThreadConfiguration = z.infer<
  typeof ChatThreadConfigurationSchema
>;
export type ChatThread = z.infer<typeof ChatThreadSchema>;
